import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalService} from '../../../vna_portal/model/PortalService';

import * as _ from 'underscore';
import {MiscelaneaService} from '../../../../../shared/services/miscelanea.service';
import {VnaPortalConfigDataParserService} from '../../../vna_portal/services/vna-portal-config-data-parser.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {PortalServiceFactoryService} from '../../../services/portal-service-factory.service';

@Component({
  selector: 'app-call-range-allowed',
  //templateUrl: './call-range-allowed.component.html',
  styleUrls: ['./call-range-allowed.component.scss']
})
export abstract class CallRangeAllowedComponent implements OnInit {

    @Input() portalService: PortalService;
    @Input() type: string = 'portal';

    form: FormGroup;

    submitted: boolean = false;
    enabled: boolean = false;

    constructor(protected formBuilder: FormBuilder, protected portalServiceFactory: PortalServiceFactoryService, protected dataParser: VnaPortalConfigDataParserService, protected miscHandler: MiscelaneaService, protected alertHandler: AlertaService) {
        this.form = new FormGroup({
            'from' : new FormControl('', Validators.required),
            'to' : new FormControl('', Validators.required)
        });
    }

    savePortalService(): void {
        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        let updateData = this.getUpdateData();
        let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService };
        if(_.indexOf(['camp', 'action'], this.type) >= 0){
            criteria['camp_pk'] = this.portalService.pkCamp;
            if(this.type == 'action'){
                criteria['action_pk'] = this.portalService['pkAction'];
            }
        }

        this
            .portalServiceFactory
            .getHandler(this.type)
            .savePortalService(criteria, 'call_parameters', this.portalService.alias, updateData)
            .subscribe(
                (result) => {
                    this.enabled = false;
                    this.alertHandler.addAlert('success', 'Config has been update successfully');
                }
            );
    }

    getUpdateData(): Object {
        let updateData: Object = { 'call_range_allowed' : { from: this.form.value['from'], to: this.form.value['to'] } };
        return updateData;
    }

    ngOnInit() {

        if(this.portalService.hasCallRangeAllowed()){
            this.form.controls['from'].setValue(this.portalService.getCallRangeAllowed()['from']);
            this.form.controls['to'].setValue(this.portalService.getCallRangeAllowed()['to']);
        }

    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/call-range-allowed/call-range-allowed.component.ts